import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { generateQuickSightEmbedReportUrl } from '../../ApiUtils/ApiUtils';
import './Reports.css';

interface ReportForAnonymousUserState {
    isLoading: boolean;
    hasError: boolean;
    embedUrl: string | null;
}

class ReportForAnonymousUser extends React.Component<any, ReportForAnonymousUserState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: true,
            hasError: false,
            embedUrl: null
        }
    }

    componentDidMount() {
        generateQuickSightEmbedReportUrl().then((result) => {
            this.setState({
                embedUrl: result.data.url
            });
        }).catch(() => {
            this.setState({
                isLoading: false,
                hasError: true
            });
        });
    }

    private handleOnLoad = () => {
        this.setState({
            isLoading: false
        });
    }

    public render() {
        return (
            <>
                <Container fluid className="h-100">
                    <Row className="h-100">
                        <Col xs={12} className="px-0 d-flex justify-content-center flex-column">
                            {this.state.isLoading && (
                                <section className="align-self-center text-center">
                                    <p>Initiating QuickSight Dashboard...</p>
                                    <FontAwesomeIcon icon={faSpinner} size="3x" spin={true} />
                                </section>
                            )}
                            {!this.state.hasError && this.state.embedUrl && (
                                <iframe width="100%" height="100%"
                                    src={this.state.embedUrl} onLoad={this.handleOnLoad}>
                                </iframe>
                            )}
                            {!this.state.isLoading && this.state.hasError && (
                                <div className="p-2 align-self-center alert alert-danger">Initiate dashboard failed</div>
                            )}
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default ReportForAnonymousUser;
